export default "__VITE_ASSET__5y2GPlTw__"